import { Col, Row } from "antd";
import LogoIcon from "@/assets/icons/Logo";
import routes from "@/routes";
import styles from "../../userRoleManagement.module.less";


function FilterComponent() {
  return (
    <Row justify="space-between" align="middle" className={styles.filterArea}>
      <Col
        flex={1}
        style={{
          height: "100%",
        }}
      >
        <div className={styles.leftContent}>
          <div className={styles.logoWrapper}>
            <LogoIcon />
            <span
              style={{
                fontSize: 14,
                color: "#234C66",
                fontWeight: 700,
              }}
            >
              {routes.userRoleList.title}
            </span>
          </div>
        </div>
      </Col>
      <Col
        style={{
          height: "100%",
        }}
      >
        <div className={styles.rightContent}>
          {/* <Link to={routes.createRole.path}>
            <ButtonRectangle>Add new user role</ButtonRectangle>
          </Link> */}
        </div>
      </Col>
    </Row>
  );
}

export default FilterComponent;
